/**
* @ngdoc service
* @name  sharebase.sbRecentDocumentsService
* 
* @description 
* A service used to retrieve user's recent documents
*
**/
export function RecentDocumentsServiceFactory(
	$http:ng.IHttpService, 
	settingsService, 
	sbLibraryService
) {
	return {
		/**
		* @ngdoc method
		* @name sbRecentDocumentsService#getDocuments
		* @methodOf sharebase.sbRecentDocumentsService
		* @kind function
		*
		* @description
		* Gets the recent document for a user
		* 
		* @returns {Deferred} A promise that will resolve with an
		* array of recent documents
		* 
		*/
		getDocuments
	};
	
	function getDocuments() {
		return $http.get(settingsService.serverAPIPath + '/recents/')
			.then(function (response) {
				return response.data;
			});
	}
}

RecentDocumentsServiceFactory.$inject =  [
	'$http',
	'settingsService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/recentDocumentsService.ts